import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esJSON from "./locales/es.json";

i18n.use(initReactI18next).init({
  resources: {
    es: {
      translation: esJSON,
    },
  },
  lng: "es",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
